import { Component } from '@angular/core';
import { FileRecordObject } from '../records/file-record';
import { FileRecordService } from '../records/file-record.service';
import { AuthService } from '../auth/services/auth-service';
import { AuthenticatedResult } from "angular-auth-oidc-client";
import { Observable } from "rxjs";

@Component({
  selector: 'home-component',
  templateUrl: './home.component.html',
  styleUrls: [ './home.component.css' ],
  providers: [AuthService]
})
export class HomeComponent  {
  activeFileRecordList: FileRecordObject[] = new Array<FileRecordObject>();
  previousFileRecordList: FileRecordObject[] = new Array<FileRecordObject>();
  name = 'Angular';
  session = null;
  isAuthenticated$: Observable<AuthenticatedResult>;

  constructor(private readonly fileRecordService: FileRecordService,
              private readonly authService: AuthService) {
    this.isAuthenticated$ = authService.isAuthenticated();
    this.isAuthenticated$.subscribe(authResult => {
      if (authResult.isAuthenticated) {
        this.authService.initializeUploaderSession().then(response => {
          this.session = sessionStorage.getItem('session');
          this.updateTableData()
        })
      }
    })
  }


  public updateTableData(): void {
    this.fileRecordService.getSessionTableContent().then(fileRecords =>  {
      if (fileRecords) {
        this.activeFileRecordList = this.fileRecordService.toFileRecordObjectList(fileRecords);
      }});
    this.fileRecordService.getHistoryTableContent().then(fileRecords =>  {
      if (fileRecords) {
        this.previousFileRecordList = this.fileRecordService.toFileRecordObjectList(fileRecords);
      }});
  }
}
